import { render, staticRenderFns } from "./Fireworks.vue?vue&type=template&id=71020c13&scoped=true"
import script from "./Fireworks.vue?vue&type=script&lang=js"
export * from "./Fireworks.vue?vue&type=script&lang=js"
import style0 from "./Fireworks.vue?vue&type=style&index=0&id=71020c13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71020c13",
  null
  
)

export default component.exports